import { createEntityMutation } from '../../createEntityMutation';
import {
  UserDefinedFieldValuesService,
  type Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_CreateUserDefinedFieldValuesDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

export const usePostUserDefinedFieldValues = createEntityMutation<
  Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_CreateUserDefinedFieldValuesDto[],
  Wealthlane_CustomerService_Dtos_UserDefinedFieldValues_CreateUserDefinedFieldValuesDto[]
>({
  mutationFn: (payload) =>
    UserDefinedFieldValuesService.postApiCustomerApiAppUserDefinedFieldValuesUserDefinedFieldValues(
      payload,
    ),
  silent: true,
});
